var ConfirmDialogModule = /** @class */ (function () {
    function ConfirmDialogModule() {
    }
    return ConfirmDialogModule;
}());
export { ConfirmDialogModule };
